/**
 * @readonly
 * @enum {String} EmailTypeEnum
 */

const EmailTypeEnum = {
  ALL            : 0,
  REPORT_ORDERS  : 1,
  REPORT_RECEIPTS: 2
}

export default EmailTypeEnum
